import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";
import { medicalConditions } from "../../data";

export function MedicalConditions() {
  return (
    <CategoryContainer title="Conditions">
      <AutocompleteRHF
        name={"sensitive.condition"}
        options={medicalConditions}
        selectLabel={"Your situations"}
        multiple={true}
      />
    </CategoryContainer>
  );
}
